import { Fragment } from "react";
import { Delete } from "@mui/icons-material";

import { DeleteDialog } from "@dzambalaorg/mui-dialog-delete";
import { PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { ListAction, ListActions, StyledListItem, StyledListWrapper } from "@framework/styled";
import { IOtp } from "@framework/types";
import { useDialogDelete, useFetchQuery } from "@dzambalaorg/react-hooks";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { List } from "@dzambalaorg/ui-kit";

import { ITabPanelProps } from "../tabs";

const MERCHANT_INVITATIONS_URL = "/invitations";

export const MerchantInvitations = (props: ITabPanelProps) => {
  const { open } = props;

  const { isLoading, allRows, refetch } = useFetchQuery<IPaginationResult<IOtp>>(MERCHANT_INVITATIONS_URL);

  const { handleDelete } = useDialogDelete<IOtp>();

  if (!open) {
    return null;
  }

  return (
    <Fragment>
      <PageHeader message="pages.merchant.tabs.invitations" />

      <ProgressOverlay isLoading={isLoading}>
        <StyledListWrapper count={allRows.length} isLoading={isLoading} message="pages.merchant.invitations.empty">
          {allRows.map(otp => (
            <StyledListItem key={otp.uuid}>
              <List.ItemText>{otp.user?.displayName}</List.ItemText>
              <ListActions>
                <ListAction message="form.tips.delete" icon={Delete} onClick={handleDelete(otp)} />
              </ListActions>
            </StyledListItem>
          ))}
        </StyledListWrapper>
      </ProgressOverlay>

      <DeleteDialog
        url={MERCHANT_INVITATIONS_URL}
        refetch={refetch}
        getTitle={(otp: IOtp) => otp.user?.displayName || ""}
      />
    </Fragment>
  );
};
